// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createStore } from "effector";
import {
  ProfileListDto,
  ProfileRightsListDto
} from "../../api/backend-openapi";
import { setProfileList, setProfileRightsList } from "./ProfilesEvents";

export const ProfilesStore = createStore<ProfileListDto>({}).on<ProfileListDto>(
  setProfileList,
  (_state: ProfileListDto, payload: ProfileListDto) => payload
);

export const ProfilesRightsStore = createStore<ProfileRightsListDto>({}).on<
  ProfileRightsListDto
>(
  setProfileRightsList,
  (_state: ProfileRightsListDto, payload: ProfileRightsListDto) => payload
);
